'use strict';

// fetch() polyfill for making API calls.
require('whatwg-fetch');
require("babel-polyfill");




//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 261
// module chunks = 0